const $ = jQuery.noConflict();
class SmoothScrollOnLoad  {
    constructor(section, header='.main-header') {
        this.section = section;
        this.header = header;
    }
    init() {
        this.smoothscroll();
    }
    smoothscroll() {
        if($(this.section).length > 0) {
            const taxonomy = $(this.section).data('filter');
            
            if(taxonomy) {
                const positionTop = $(this.section).offset().top;
                const headerHeight = $(this.header).outerHeight();
                const distance = positionTop - headerHeight;
                $('html, body').animate({
                    scrollTop: distance,
                }, 600);
            }
        }
    }
}

const scrollToBlogPosts = new SmoothScrollOnLoad('body.category .blog-posts');
const scrollToCLArchive =  new SmoothScrollOnLoad('.cl-posts');
const scrollToSJArchive =  new SmoothScrollOnLoad('.archive-posts--sj');

export default scrollToBlogPosts;
export { scrollToCLArchive, scrollToSJArchive }
